import { FilterOperator, MetricView, ProductExternal } from '@nemuru-eng/js-api-client';

import { QueryBuilder } from '../QueryBuilder';
import { MetricFilter } from './MetricFilter';

type CustomMetricView = MetricView & { productExternal: ProductExternal };

export class ProductExternalFilter extends MetricFilter<ProductExternal> {
  public field = 'product_external';
  public operator = FilterOperator.IN;

  constructor(productExternal?: ProductExternal[]) {
    super(productExternal);
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    const newFilter = newQueryBuilder.metricFilter<ProductExternalFilter>(this);
    if (this.areValuesIncluded(newFilter)) return false;
    return true;
  }

  public merge(newFilter: ProductExternalFilter): this {
    if (!(newFilter instanceof ProductExternalFilter)) return this;
    if (newFilter.values === undefined) return new ProductExternalFilter(undefined) as this;
    if (this.areValuesIncluded(newFilter)) return this;
    const uniqueValues = Array.from(new Set([...this.values, ...newFilter.values]));
    return new ProductExternalFilter(uniqueValues) as this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    if (!this.values) return metrics;
    return (metrics as unknown as CustomMetricView[]).filter((metric) =>
      this.values.some((value) => value === metric.productExternal),
    ) as unknown as K[];
  }
}
